import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import PushNotiApi from "api/pushNotiApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import ModalPreview from "components/Common/ModalPreview";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import {
  COLOR_STATUS_ACTIVE_DISABLE,
  NOTI_SETTING_STATUS_OPTION,
  NOTI_SETTING_TYPE_OPTION,
} from "helpers/constans";
import {
  formatDateStringToKorea,
  formatNumberWithCommas,
} from "helpers/format";
import CountUp from "react-countup";
import CreateEditAdsPlan from "./CreateEditPlan";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import { getAdsPlan } from "store/ads/thunk";
import CollapseFilter from "components/Common/CollapseFilter";
import LabelWrapper from "components/Common/LabelWrapper";
import DropdownStatus from "components/Common/DropdownStatus";

interface Option {
  label: string;
  value: string;
}
export interface Tag {
  id: string;
  text: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const MediaList = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const STATUS_OPTION_LANG =
    NOTI_SETTING_STATUS_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    content: withDefault(StringParam, ""),
    keyword: withDefault(StringParam, ""),
    "condition[status]": withDefault(StringParam, ""),
    "condition[type]": withDefault(StringParam, ""),
    startDate: withDefault(StringParam, ""),
    endDate: withDefault(StringParam, ""),

    // sort_by: withDefault(StringParam, "createdAt"),
    // order_by: withDefault(StringParam, "DESC"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [typesSearch, setTypesSearch] = useState<Option | null>();
  const [keywordSearch, setKeywordSearch] = useState<string>(
    query?.keyword || ""
  );
  const [statusSearch, setStatusSearch] = useState<Option | null>(
    STATUS_OPTION_LANG?.find(
      (item) => String(item?.value) === String(query["condition[status]"])
    ) || null
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.AdsPlan;
  const AdsPlanProperties = createSelector(selectLayoutState, (state) => ({
    adsPlan: state.adsPlan,
    isAdsPlanLoading: state.isAdsPlanLoading,
    isAdsPlanSuccess: state.isAdsPlanSuccess,

    error: state.error,
  }));

  // Inside your component
  const { adsPlan, isAdsPlanLoading } = useSelector(AdsPlanProperties);

  function loadTableData() {
    dispatch(getAdsPlan(query));
  }

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  const [linkImage, setLinkImage] = useState<any>(null);
  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const searchData = () => {
    setQuery({
      ...query,
      keyword: keywordSearch || "",
      "condition[status]": statusSearch?.value || "",
      "condition[type]": typesSearch?.value || "",
      // sort_by: "createdAt",
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        "condition[status]": "",
        "condition[type]": "",
        sort_by: "createdAt",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setKeywordSearch((_prev) => "");
    setStatusSearch((_prev) => null);
    setTypesSearch((_prev) => null);
  };

  // Begin::Change status
  // const [itemUpdate, setItemUpdate] = useState<{ id: number | string, status: string | boolean } | null>(null);
  const [isLoadingUpdate, setIsLoadingUpdate] = useState<boolean>(false);
  // const handleShowConfirmUpdate = (item: { id: number | string, status: string | boolean }) => {
  //   setItemUpdate(item);
  // };
  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    status: string | boolean;
  }) => {
    try {
      if (!item) {
        return;
      }
      setIsLoadingUpdate((_prev) => true);
      const response: any = await PushNotiApi?.updatePushNoti(item?.id, {
        status: item?.status,
      });
      setIsLoadingUpdate((_prev) => false);
      if (response?.success) {
        // setItemUpdate((_prev) => null);
        loadTableData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingUpdate((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Change status

  // Begin:: handle select table

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        Cell: ({ ...props }) => {
          return (
            <div>
              {adsPlan?.meta?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },

      {
        Header: t("Package ID"),
        accessor: "code",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => {
          return cell?.value;
        },
      },

      {
        Header: t("Package Name"),
        accessor: "name",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => {
          return cell?.value;
        },
      },

      {
        Header: t("Description"),
        accessor: "description",
        filterable: true,
        sortable: false,
        thWidth: 250,
        Cell: (cell: any) => {
          return cell?.value;
        },
      },

      {
        Header: t("Pricing Model"),
        accessor: "pricing_model",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => {
          return cell?.value;
        },
      },

      {
        Header: t("Is Default"),
        accessor: "is_default",
        filterable: true,
        sortable: false,
        thWidth: 140,
        thClass: "text-center",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="is_default"
                checked={!!cell?.value}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  console.log(value)
                }}
              />
            </div>
          );
        },
      },

      {
        Header: t("Monthly Fee"),
        accessor: "monthly_fee",
        filterable: true,
        sortable: false,
        thWidth: 120,
        thClass: "text-end",
        Cell: (cell: any) => {
          const price = cell?.row?.original?.monthly_fee;
          return (
            <>
              <div className="text-end">
                {formatNumberWithCommas(price)} ₩
              </div>
            </>
          );
        },
      },
      {
        Header: t("Cost Per Click"),
        accessor: "cost_per_click",
        filterable: true,
        sortable: false,
        thWidth: 120,
        thClass: "text-end",
        Cell: (cell: any) => {
          return <div className="text-end">{cell?.value ? formatNumberWithCommas(cell?.value) + '₩' : 0 } </div>;
        },
      },

      {
        Header: t("Free Period Months"),
        accessor: "free_per_month",
        filterable: true,
        sortable: false,
        thWidth: 160,
        thClass: "text-end",
        Cell: (cell: any) => {
          return <div className="text-end">{formatNumberWithCommas(cell?.value)} {cell?.value > 1 ? t('months') : t('month')}</div>;
        },
      },
      {
        Header: t("Default Budget"),
        accessor: "default_budget",
        filterable: true,
        sortable: false,
        thWidth: 140,
        thClass: "text-end",
        Cell: (cell: any) => {
          return <div className="text-end">{formatNumberWithCommas(cell?.value)} ₩</div>;
        },
      },

      {
        Header: t("Target Options"),
        accessor: "target_options",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-center",
        Cell: (cell: any) => {
          return cell?.value;
        },
      },

      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },

      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`update-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-primary edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpen(true);
                      setItemToEdit(item);
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom "></i>
                  </Link>
                </li>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    [i18n?.language, userPermissions, adsPlan?.meta?.total]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  useEffect(() => {
    document.title = `${t("Package")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Package")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="packageList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={adsPlan?.meta?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-md-2 mt-0">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Keyword")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Keyword")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatus
                            name="status"
                            dataList={STATUS_OPTION_LANG || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch || null}
                            onChangeSelect={(e: any) => setStatusSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_ACTIVE_DISABLE}
                          />
                        </LabelWrapper>
                      </Col> */}

                      <Col
                        sm={3}
                        md={9}
                        xl={9}
                        xxl={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-3 mt-md-2"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                            disabled={isAdsPlanLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-feed-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={adsPlan?.list?.length ? adsPlan?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={adsPlan?.meta?.total}
                      customPageCount={Math.ceil(
                        Number(adsPlan?.meta?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isAdsPlanLoading}
                      defaultScrollBottom={adsPlan?.list?.length < 5 ? true : false}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <CreateEditAdsPlan
            setIsOpen={setIsOpen}
            item={itemToEdit}
            setItemToEdit={setItemToEdit}
            loadTableData={loadTableData}
            setLinkImage={setLinkImage}
            onCloseImageClick={onCloseImageClick}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default MediaList;
